
/* styles */
require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-559a836b!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NecessidadesEspeciais.vue")

var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NecessidadesEspeciais.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-559a836b!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NecessidadesEspeciais.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/pessoal/components/minha-conta/editar-meus-dados/NecessidadesEspeciais.vue
// module id = 512
// module chunks = 2